import { ReactElement } from 'react';

export type ColumnHeaderUi = {
  readonly label: string;
  readonly info?: string;
  readonly sortListener?: (type: 'asc' | 'desc') => void;
};

export type PagingUi = {
  readonly pageCount: number;
  readonly currentPage: number;
  readonly boundaryCount?: number;
  readonly siblingCount?: number;
};

export const DEFAULT_PAGING_BOUNDARY_COUNT = 3;
export const DEFAULT_SIBILING_BOUNDARY_COUNT = 5;

export type TableDataProperties<T> = {
  readonly columnHeaders: ColumnHeaderUi[];
  readonly roundedTop?: boolean;
  readonly compact?: boolean;
  readonly items: T[];
  readonly rowItemGenerator: (item: T) => ReactElement[];
  readonly onRowClick?: (data: T) => void;
  readonly paging?: PagingUi;
  readonly onPageSelected?: (page: number) => void;
};
